import { cn } from '@utils'
import { getUserInitials } from '@utils/userInitials'

/**
 * Circular user avatar — shows profile photo when available, otherwise initials.
 */
export function UserAvatarCircle({ user, size = 32, className, textClassName }) {
  const initials = getUserInitials(user)
  const dimension = { width: size, height: size }

  if (user?.avatarUrl) {
    return (
      <img
        src={user.avatarUrl}
        alt={user?.name ? `${user.name} profile photo` : 'Profile photo'}
        className={cn('rounded-full object-cover flex-shrink-0 select-none', className)}
        style={dimension}
      />
    )
  }

  return (
    <div
      className={cn(
        'rounded-full flex items-center justify-center font-semibold flex-shrink-0 select-none text-white',
        className,
      )}
      style={{ ...dimension, background: 'var(--ac-secondary)', fontSize: Math.max(10, Math.round(size * 0.34)) }}
      aria-hidden={!user?.name}
      aria-label={user?.name ? `${user.name} avatar` : undefined}
    >
      <span className={textClassName}>{initials}</span>
    </div>
  )
}
